module.exports = __webpack_public_path__ + "static/media/wrench.25ba5995.svg";